import TrackedStep, { TrackedStepJSON } from './TrackedStep';
import { Schema } from 'prosemirror-model';

export default class Commit {
  time;
  trackedSteps;
  constructor(time, trackedSteps) {
    this.time = time;
    this.trackedSteps = trackedSteps;
  }

  toJSON() {
    return {
      time: this.time.toJSON(),
      trackedSteps: this.trackedSteps.map(trackedStep => trackedStep.toJSON())
    };
  }

  static fromJSON(obj, schema) {
    return new Commit(
      new Date(obj.time),
      obj.trackedSteps.map(trackedStep => TrackedStep.fromJSON(trackedStep, schema))
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/Commit.js